import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((cfg) => {
  const token = localStorage.getItem("berulia_token");
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

// On 401 from a request that carried a token, the token is expired or revoked.
// Clear it and notify AuthProvider so route guards redirect to the right login.
// Skip the login/register endpoints — their 401s are user-facing form errors.
api.interceptors.response.use(
  (r) => r,
  (err) => {
    const status = err?.response?.status;
    const url = err?.config?.url || "";
    const isAuthEntry = url.includes("/auth/login") || url.includes("/auth/register");
    if (status === 401 && !isAuthEntry && localStorage.getItem("berulia_token")) {
      localStorage.removeItem("berulia_token");
      window.dispatchEvent(new CustomEvent("berulia:auth-expired"));
    }
    return Promise.reject(err);
  }
);

export const LOGO_URL = "/logo.png";
